import { snakeCase } from 'lodash';
import { useGlobalSelector } from '../utils/globalVariables';

const useIsImmo = (): boolean => {
  const themeName = useGlobalSelector((state) => state.generalData.themeName);
  return snakeCase(themeName) === 'immotheker_orange';
};

export default useIsImmo;
